<template>
  <div
    v-if="categories.length"
    class="pr-4"
  >
    <article
      v-if="stats"
      class="card flex flex-col md:flex-row"
    >
      <div class="text-center flex-1">
        <h1
          class="text-4xl mb-0"
          v-text="stats.discussions.new"
        />
        <p
          class="uppercase text-grey-darker mt-0"
          v-text="'Unread Discussions'"
        />
      </div>
      <div class="text-center flex-1">
        <h1
          class="text-4xl mb-0"
          v-text="stats.discussions.active"
        />
        <p
          class="uppercase text-grey-darker mt-0"
          v-text="'Active Discussions'"
        />
      </div>
      <div
        v-can="'archive-discussions'"
        class="text-center flex-1"
      >
        <h1
          class="text-4xl mb-0"
          v-text="stats.discussions.archived"
        />
        <p
          class="uppercase text-grey-darker mt-0"
          v-text="'Archived Discussions'"
        />
      </div>
    </article>
  </div>
</template>

<script type="text/babel">
import { mapState } from 'vuex'

export default {
  name: 'DiscussionStats',
  data() {
    return {
      stats: false,
    }
  },
  computed: {
    ...mapState({
      categories: state => state.discussion.categories.data,
    }),
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$api.active().get('discussions/stats').then((response) => {
        this.stats = response.data

        this.$emit('loaded')
      })
    },
  },
}
</script>
